import type { Fallacy } from "./types";
import { createStory } from "./types";

export const argumentFromIgnorance: Fallacy = {
    id: "argument-from-ignorance",
    name: "Argument from Ignorance",
    emoji: "🕳️",
    category: "Argumen Lemah",
    description:
      "Menganggap sesuatu benar karena **belum terbukti salah**, atau sebaliknya. **Ketiadaan bukti ≠ bukti ketiadaan**.",
    tldr: "Belum terbukti salah bukan berarti benar. Mana buktinya?",
    detail:
      "Argument from Ignorance adalah kesalahan logika di mana seseorang mengklaim sesuatu pasti benar karena **belum ada yang membuktikan sebaliknya**, atau pasti salah karena **belum ada yang membuktikan kebenarannya**.\n\nKetiadaan bukti hanya berarti kita BELUM TAHU — bukan berarti kita sudah tahu jawabannya.\n\nKenapa ini fallacy? Karena **beban pembuktian** (burden of proof) ada pada **yang membuat klaim**, bukan pada yang meragukan. Setiap kali argumen bergantung pada ketiadaan bukti sebagai 'bukti', itu Argument from Ignorance.",
    story: createStory("Argument from Ignorance", "🕳️", {
      hook: {
        title: "Gak ada yang bisa buktiin salah...",
        body: "Berarti bener dong? Eits, yakin logikanya kayak gitu?",
      },
      convo: {
        claim: "Jimat ini beneran works loh. Emang ada yang bisa buktiin **jimat ini gak berhasil**? Gak ada kan? Ribuan pembeli puas semua.",
        response: "Yang harus kasih bukti itu yang jualan. **Gak bisa dibantah ≠ terbukti.**",
      },
      reveal: {
        body: "Kamu nganggep sesuatu **bener cuma karena belum terbukti salah** — atau sebaliknya. Padahal belum tahu ≠ sudah tahu jawabannya.",
      },
      insight: {
        title: "Aturan simpelnya?",
        body: "Yang bikin klaim, dia yang harus kasih bukti. **\"Belum terbukti salah\" bukan berarti benar** — itu cuma berarti kita belum tau.",
      },
      engagement: {
        title: "Hal apa yang kamu percaya cuma karena \"belum terbukti salah\"?",
        body: "Jimat, ramalan zodiak, atau teori konspirasi? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "circular-reasoning", "appeal-to-nature"],
  };
